import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL, ATTACH_SERVER } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
// @ts-ignore
import Rodal from "rodal";
import { Link } from "react-router-dom";
var qs = require("qs");
var ThemeList = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeList, _super);
    function ThemeList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            newTheme: '',
            themes: [],
            page: 0,
            pageSize: 20,
            loading: true,
            currentTheme: { title: '', id: null, file_id: null, icon: '' },
            showRodal: false,
        };
        return _this;
    }
    ThemeList.prototype.componentWillMount = function () {
        this.getThemes();
    };
    ThemeList.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'id',
                width: 100,
                style: { textAlign: 'center' }
            }, {
                Header: 'Название',
                accessor: 'title',
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    return (React.createElement("div", { className: "btn-group" },
                        React.createElement(Link, { to: "/themes/" + props.row.id + "/subthemes", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-eye" })),
                        React.createElement("button", { onClick: _this.editTheme.bind(_this, props.row._original), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-edit" })),
                        React.createElement("button", { onClick: _this.removeTheme.bind(_this, props.row.id), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-trash" }))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement(Rodal, { onClose: function () {
                    _this.setState({ showRodal: false, currentTheme: { title: '', icon: '', file_id: null, id: null } });
                }, visible: this.state.showRodal, width: 400, height: 400 },
                React.createElement("div", { className: "form-group" },
                    "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u0435\u043C\u044B",
                    React.createElement("input", { className: "form-control cols-xs-12", style: { width: '100%' }, name: "name", onChange: function (e) {
                            var value = e.target.value;
                            _this.setState(function (prevState) {
                                var cc = prevState.currentTheme;
                                cc.title = value;
                                return { currentTheme: cc };
                            });
                        }, value: this.state.currentTheme.title, type: "text" })),
                React.createElement("div", { className: "form-group" },
                    "\u0418\u043A\u043E\u043D\u043A\u0430",
                    React.createElement("br", null),
                    this.state.currentTheme.icon.length > 0 && (React.createElement("img", { width: "50", height: "50", src: this.state.currentTheme.icon })),
                    React.createElement("input", { type: 'file', onChange: function (e) {
                            if (e.target.files) {
                                _this.handleChange(e.target.files);
                            }
                            e.target.value = '';
                        } })),
                React.createElement("button", { type: 'button', onClick: this.updateTheme.bind(this), className: "btn btn-primary btn-lg btn-block", style: { color: '#fff' } }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null, "\u0422\u0435\u043C\u044B")),
                React.createElement("div", { className: "col col-xs-3 pull-right" },
                    React.createElement("input", { placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u0435\u043C\u044B", type: "text", value: this.state.newTheme, onChange: function (e) { _this.setState({ newTheme: e.target.value }); } }),
                    "\u0418\u043A\u043E\u043D\u043A\u0430",
                    React.createElement("input", { type: 'file', onChange: function (e) {
                            if (e.target.files) {
                                _this.handleChange(e.target.files);
                            }
                            e.target.value = '';
                        } }),
                    React.createElement("button", { onClick: this.newTheme.bind(this), className: "btn btn-primary", style: { color: '#fff' } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0435\u043C\u0443")),
                React.createElement("br", null),
                this.state.currentTheme.icon.length > 0 && (React.createElement("img", { width: "50", height: "50", className: "pull-right", src: this.state.currentTheme.icon }))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: 'Loading...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.themes, columns: columns })))));
    };
    ThemeList.prototype.getThemes = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&sort=' + this.state.sort + '&limit=' + this.state.pageSize;
        axios.get(API_URL + '/themes?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                themes: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    ThemeList.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () { return _this.getThemes(); });
    };
    ThemeList.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getThemes(); });
    };
    ThemeList.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getThemes();
        });
    };
    ThemeList.prototype.removeTheme = function (id) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите удалить тему?');
        if (result) {
            axios.delete(API_URL + '/theme/' + id, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getThemes();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    ThemeList.prototype.newTheme = function () {
        var _this = this;
        var result = confirm('Добавить тему?');
        if (result && this.state.newTheme.trim().length > 0) {
            axios.post(API_URL + '/theme', qs.stringify({
                title: this.state.newTheme,
                file_id: this.state.currentTheme.file_id,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                toastr.success('Успех', 'Тема добавлена');
                _this.setState({ newTheme: '' }, function () {
                    _this.getThemes();
                });
            }).catch(function (e) {
                if (e.response && e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    ThemeList.prototype.editTheme = function (theme) {
        this.setState({ showRodal: true, currentTheme: theme });
    };
    ThemeList.prototype.updateTheme = function () {
        var _this = this;
        if (this.state.currentTheme.title.trim().length > 0) {
            axios.put(API_URL + '/theme/' + this.state.currentTheme.id, qs.stringify({
                title: this.state.currentTheme.title,
                file_id: this.state.currentTheme.file_id,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                toastr.success('Успех', 'Тема обновлена');
                _this.setState({ currentTheme: { title: '', id: null, file_id: null, icon: '' }, showRodal: false }, function () {
                    _this.getThemes();
                });
            }).catch(function (e) {
                if (e.response && e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response && (e.response.data.code === 406 || e.response.data.code === 409)) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    ThemeList.prototype.handleChange = function (files) {
        var _this = this;
        var file = files[0];
        var height = 0;
        var width = 0;
        if (file.type !== "image/png") {
            alert("Изображение должно быть png формата");
            return;
        }
        var img = new Image();
        img.onload = function () {
            height = img.height;
            width = img.width;
            if (width !== height) {
                alert("Изображение должно быть равносторонним.");
                return;
            }
            var data = new FormData();
            data.append('upload', file);
            axios.post(ATTACH_SERVER + '/upload/', data, {
                headers: {
                    'Authorization': 'Bearer ' + _this.props.auth_token,
                },
            })
                .then(function (res) {
                _this.setState(function (prevState) {
                    var cc = prevState.currentTheme;
                    cc.icon = res.data.data.link_to_thumb;
                    cc.file_id = res.data.data.id;
                    return { currentTheme: cc };
                });
            })
                .catch(function (err) {
                if (err.response && err.response.data && err.response.data.error) {
                    toastr.error('Ошибка', err.response.data.error);
                }
            });
        };
        img.src = URL.createObjectURL(files[0]);
    };
    return ThemeList;
}(React.Component));
export default connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(ThemeList);



//////////////////
// WEBPACK FOOTER
// ./src/views/themes/index.tsx
// module id = 529
// module chunks = 0